import { Chip } from "@mui/material";
import { useMemo } from "react";
import { GetTaskStateBackgroundColor, GetTaskStateTextColor } from "../../../common/mission";
import { makeStyles } from "tss-react/mui";
import { TaskEnums } from "../../../common/constants";

const useStyles = makeStyles()(
  () => ({
    textContrastOverride: {
      "& span span": {
        color: "#FFF !important"
      }
    }
  })
);

export default function TaskStateChip(props) {
  const { className, label, size, state, driverAssignedState } = props;
  const { classes } = useStyles();

  return (
    <Chip
      size={size}
      className={`${state === TaskEnums.State.Responded && driverAssignedState === TaskEnums.DriverAssignedState.Rejected ? classes.textContrastOverride : ""} ${className || ""}`}
      label={label}
      style={useMemo(() => ({
        color: GetTaskStateTextColor(state, driverAssignedState),
        backgroundColor: GetTaskStateBackgroundColor(state, driverAssignedState)
      }), [state, driverAssignedState])}
    />
  )
}